import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import "aos/dist/aos.css";
import './styles.css';
import './infografico.css';
import pmsChart from './pmsChart';
import cmsChart from './cmsChart';
import videoBackground from '../../assets/video/video.mp4';
import windintelliBackground from '../../assets/video/windintelli.mp4';
import waiting from '../../assets/video/waiting.png';
import windintellilogo from '../../assets/images/logo_windintelli.png';
import windintelliWaiting from '../../assets/images/windintelli_loading.png';
import infografico from '../../assets/images/infografico_new_blue.png'
import turbineHome from '../../assets/images/turbine_home.jpg'
// import infograficoblue from '../../assets/images/infografico_blue.png'

import mapBrasil from '../../assets/images/brasilmaphome.jpg';
import appleStoreIcon from '../../assets/images/destaque/applestore.png';
import googlePlayIcon from '../../assets/images/destaque/googleplay.png';
import browserIcon from '../../assets/images/destaque/browser.png';
import turbineImg from '../../assets/images/destaque/turbine.jpg';
import windintelliImgDestaque from '../../assets/images/destaque/windintelli.jpg';

function Home() {
  const [optionsPMS, setOptionsPMS] = useState(pmsChart) 
  const [optionsCMS, ] = useState(cmsChart)
  const [focus, setFocus] = React.useState(false);
  
  useEffect(() => {
    AOS.init()
    window.scrollTo({
      top: 0,
      left: 0,
    })
    setInterval(() => {
      updateChart()
    }, 4000 );
  }, [])
  
  const updateChart = () => {
    setOptionsPMS({
      series: [
      {
        data: [[3, 0], [4, Math.random() * (28 - 10) + 10], [5, Math.random() * (144 - 100) + 100], 
        [6, Math.random() * (309 - 250) + 250], [7, Math.random() * (511 - 400) + 400], [8, Math.random() * (758 - 720) + 720], 
        [9, Math.random() * (999 - 900) + 900], [10, Math.random() * (1220 - 1050) + 1050], [11, Math.random() * (1488 - 1400) + 1400], 
        [12, Math.random() * (1637 - 1450) + 1450], [13, Math.random() * (1650 - 1500) + 1500],
        [14, Math.random() * (1650 - 1500) + 1500], [15, Math.random() * (1650 - 1500) + 1500], [16, Math.random() * (1650 - 1500) + 1500]],
      }]
    })
  }
  return (
    <div>
      <Header />
      <div className="background">
        <figure></figure>
        <figure></figure>
        <div className="bg"></div>
        <video autoPlay muted loop id="myVideo" playsInline  poster={waiting} >
          <source src={videoBackground} type="video/mp4" />
        </video>
        <div className="container">
          <div className="banner content">
            <h1>The Pioneer Brazilian Wind Energy Company</h1>
            <p>
              Eólica Tecnologia Ltda is one of the leading companies in wind farm development and operation in Brazil. 
              <br /> A company that develops, constructs and operates renewable energy projects, playing an active role in the country. 
              <br/>Excellence in projects -  a unique value of Eólica Tecnologia. Acting in Brazil since 2000.  
            </p>
          </div>
        </div>
      </div>
      
      <div className="work-bg grey-bg  overflow-destaque">
        <div className="container">
          <div className="content">
            <div className="container">
              <Row className="first-box">
                <Col xs={12} md={6} sm={12} lg={6} className="destaque-turbine">
                  <img src={mapBrasil} alt="turbine" />
                </Col>
                <Col xs={12} md={6} sm={12} lg={6} className="excellence-text" data-aos-once="true" data-aos="slide-left" data-aos-duration="1000">
                  <h1>Excellence in Construction and Installation</h1>
                  <p>Eólica Tecnologia has built over 300 MW of wind farms in several locations in the Northeast of Brazil.</p>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className="home-construction-highlights">
        <div className="overflow-hidden">
          <div className="container" >
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={12} className="col-home-highlights left-40-padding oem-info">  
                  <div className="box-infografico">
                    <div className="whatever">
                      <div className="circle-infografico-1" data-aos-once="true" data-aos="fade-down-left" data-aos-duration="1500" data-aos-delay="500">
                        <div className="circle-infografico-numbers">
                          <h3> 
                            <CountUp start={focus ? 0 : null} end={2}  decimals={2} duration={3} redraw={true} delay={0.8}>
                              {({ countUpRef }) => (
                                <div>
                                  <VisibilitySensor
                                    onChange={isVisible => {
                                      if (isVisible) {
                                        setFocus(true);
                                      } 
                                    }}
                                  >
                                    <span ref={countUpRef} />
                                  </VisibilitySensor>
                                </div>
                              )}
                            </CountUp>
                          </h3> 
                          <h4> GW </h4>
                        </div>
                        <p>in Development</p>
                      </div>
                      <div className="circle-infografico-2" data-aos-once="true" data-aos="fade-up-left" data-aos-duration="2000" data-aos-delay="1700">
                        <div className="circle-infografico-numbers">
                          <h3>
                            <CountUp start={focus ? 0 : null} end={81} duration={3} delay={2} redraw={true}>
                              {({ countUpRef }) => (
                                <div>
                                  <VisibilitySensor
                                    onChange={isVisible => {
                                      if (isVisible) {
                                        setFocus(true);
                                      } 
                                    }}
                                  >
                                    <span ref={countUpRef} />
                                  </VisibilitySensor>
                                </div>
                              )}
                            </CountUp>
                          </h3>
                          <h4> MW </h4>
                         </div>
                          <p>Solar in <br/>Construction</p>
                      </div>
                      <div className="circle-infografico-3" data-aos-once="true" data-aos="zoom-in" data-aos-duration="2000" data-aos-delay="1000">
                        <div className="circle-infografico-numbers">
                          <h3>
                            <CountUp start={focus ? 0 : null} end={195} duration={3} delay={1.3} redraw={true}>
                              {({ countUpRef }) => (
                                <div>
                                  <VisibilitySensor
                                    onChange={isVisible => {
                                      if (isVisible) {
                                        setFocus(true);
                                      } 
                                    }}
                                  >
                                    <span ref={countUpRef} />
                                  </VisibilitySensor>
                                </div>
                              )}
                            </CountUp></h3> 
                          <h4> MW </h4>
                        </div>
                          <p>Wind in <br/>Operation</p>
                      </div>
                      <div className="circle-infografico-4" data-aos-once="true" data-aos="fade-up-right" data-aos-duration="1500" data-aos-delay="1200">
                        <div className="circle-infografico-numbers">
                          <h3>
                            <CountUp start={focus ? 0 : null} end={94} duration={3} delay={1.5} redraw={true}>
                              {({ countUpRef }) => (
                                <div>
                                  <VisibilitySensor
                                    onChange={isVisible => {
                                      if (isVisible) {
                                        setFocus(true);
                                      } 
                                    }}
                                  >
                                    <span ref={countUpRef} />
                                  </VisibilitySensor>
                                </div>
                              )}
                            </CountUp>
                          </h3> 
                          <h4> MW </h4>
                        </div>
                          <p>Wind in <br/>Construction</p>
                      </div>
                    </div>
                    <img data-aos-once="true" data-aos="slide-up" data-aos-duration="1000" src={infografico} alt="info" className="img-infografico"/>
                  </div>
                  <div className="learn-more-center" data-aos-once="true"  data-aos="zoom-in" data-aos-duration="2000" data-aos-delay="2000">
                    <a href="#/aboutus"><button className="learn-more-button">Learn more about Eólica</button></a>
                  </div> 
                </Col>
              </Row>
            </Container>
          </div>
        </div> 
      </div>

     <div className="work-bg grey-bg  overflow-destaque">
        <div className="container">
          <div className="content">
            <div className="container">
              <Row className="second-box">
                <Col xs={12} md={6} sm={12} lg={6} className="excellence-text" data-aos-once="true" data-aos="slide-right" data-aos-duration="1000">
                  <h1>Pioneers in Wind Energy operation in Brazil</h1>
                  <p>
                  With our Smart O&M systems, we are able to reduce maintenance costs and unplanned downtimes.  <br />
                  Our actions results in more availability, quality, reliability and extension of the wind turbine´s lifetime.
                  </p>
                </Col>
                <Col xs={12} md={6} sm={12} lg={6} className="destaque-turbine">
                  <img src={turbineHome} alt="turbine" />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      
      <div className="home-windintelli-highlights">
        <video autoPlay muted loop poster={windintelliWaiting} playsInline  id="windintelliVideo">
          <source src={windintelliBackground} type="video/mp4" />
        </video>
        <div className="overflow-hidden">
          <div className="container" >
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={12} className="col-home-highlights oem-info" data-aos-once="true" data-aos="slide-up" data-aos-duration="1000">
                  <img src={windintellilogo} alt="logo" />
                  <p>Eólica Tecnologia developed its own online plataform to optimize the production and reduce O&M costs of its own wind farms</p>
                  <div className="learn-more-windintelli" data-aos-once="true" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="600">
                    <a href="#/windintelli"><button className="learn-more-button">Learn more</button></a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div> 
      </div>

      <div className="home-cms-highlights">
        <div className="whatever">
          <div className="home-cms-circle" style={{animationDelay: '0s'}}></div>
          <div className="home-cms-circle" style={{animationDelay: '1s'}}></div>
          <div className="home-cms-circle" style={{animationDelay: '2s'}}></div>
          <div className="home-cms-circle" style={{animationDelay: '3s'}}></div>
        </div>
        <div className="overflow-hidden">
          <div className="container" >
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={6} className="col-home-highlights oem-info">
                  <div className="highcharts-div" data-aos-once="true" data-aos="zoom-in" data-aos-duration="2000" data-aos-delay="200">
                    <HighchartsReact
                      allowChartUpdate={true}
                      highcharts={Highcharts}
                      options={optionsCMS}
                    />
                  </div>
                </Col>
                <Col xs={12} md={12} sm={12} lg={6} className="col-home-highlights oem-info order-1">
                  <div className="learn-more">
                    <h5>Condition Monitoring</h5>
                    <p>Eólica Tecnologia uses vibration spectrum analysis in the operation and maintenance of wind farms in order to minimize planned and unplanned breakdowns, maximize wind farm availability, and prevent unexpected faults</p>
                    <div data-aos-once="true">
                      <a href="#/windintelli"><button className="learn-more-button">Learn more</button></a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div> 
      </div>

      <div className="home-pms-highlights">
        <div className="whatever">
          <div className="home-pms-circle" style={{animationDelay: '0s'}}></div>
          <div className="home-pms-circle" style={{animationDelay: '1s'}}></div>
          <div className="home-pms-circle" style={{animationDelay: '2s'}}></div>
          <div className="home-pms-circle" style={{animationDelay: '3s'}}></div>
        </div>
        <div className="overflow-hidden">
          <div className="container" >
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={6} className="col-home-highlights oem-info">
                  <div className="learn-more">
                    <h5>Performance Monitoring</h5>
                    <p>Eólica Tecnologia developed its own Performance Monitoring System (PMS) based on operational data acquired from the SCADA system in order to optimize the production and reduce O&M costs of the wind farms.</p>
                    <div>
                      <a href="#/windintelli"><button className="learn-more-button">Learn more</button></a>             
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} sm={12} lg={6} className="col-home-highlights oem-info">
                 <div className="highcharts-div" data-aos-once="true" data-aos="zoom-in" data-aos-duration="2000" data-aos-delay="200">
                    <HighchartsReact
                      allowChartUpdate={true}
                      highcharts={Highcharts}
                      options={optionsPMS}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div> 
      </div>

      <div className="work-bg grey-bg  overflow-destaque">
        <div className="container">
          <div className="content">
            <div className="container">
              <Row>
                <Col xs={12} md={6} sm={12} lg={6} className="destaque-turbine">
                  <img src={turbineImg} alt="turbine" />
                </Col>
                <Col xs={12} md={6} sm={12} lg={6} className="destaque-text-section">
                  <div className="destaque-text-box">
                    <h3 className="destaque-text">
                      Would you like to
                    </h3>
                    <h3 className="destaque-text">
                      know more about our
                    </h3>
                    <h3 className="destaque-text-lighter">
                      Online Platform?
                    </h3>
                  </div>
                  <Row className="destaque-icon-row">
                    <Col xs={6} md={4} sm={6} lg={4} className="destaque-icon"  data-aos-once="true" data-aos="slide-left" data-aos-duration="1000" data-aos-delay="200">
                      <a href="https://play.google.com/store/apps/details?id=com.eolicatecnologia.windintelli" target="_blank" rel="noopener noreferrer">
                        <img src={googlePlayIcon} alt="turbine"/> 
                      </a>
                    </Col>
                    <Col xs={6} md={4} sm={6} lg={4} className="destaque-icon"  data-aos-once="true" data-aos="slide-left" data-aos-duration="1000" data-aos-delay="200">
                      <a href="https://apps.apple.com/br/app/windintelli/id1470153577" target="_blank" rel="noopener noreferrer">
                        <img src={appleStoreIcon} alt="turbine" />
                      </a>
                    </Col>
                    <Col xs={6} md={4} sm={6} lg={4} className="destaque-icon"  data-aos-once="true" data-aos="slide-left" data-aos-duration="1000" data-aos-delay="200">
                      <a href="https://www.windintelli.com" target="_blank" rel="noopener noreferrer">
                        <img src={browserIcon} alt="turbine" />
                      </a>
                    </Col>
                    <Col xs={6} md={6} sm={6} lg={6} className="destaque-icon-windintelli"  data-aos-once="true" data-aos="slide-up" data-aos-duration="1000" data-aos-delay="200">
                      <a href="#/windintelli">
                        <img src={windintelliImgDestaque} alt="turbine" />
                      </a>
                    </Col>
                    <Col xs={12} md={6} sm={12} lg={6} className="destaque-icon-windintelli">
                      &nbsp;
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </div>
  )
}

export default Home;